import router from '../../shared/router';
import MenuService from '../../core/components/sidebar/MenuService';
import MenuItem from '../../core/components/sidebar/MenuItem';
import Home from './Home';

const {routes} = router.options;
const route = routes.find(r => r.path === '/');

const tmpRoutes = [
  {
    path: 'home',
    name: 'home',
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
];

tmpRoutes.forEach((obj) => {
  route.children.push(obj);
});

router.addRoutes([route]);
// MenuService.addItem(new MenuItem('home', {
//   path: '/home',
//   text: 'Home',
//   uuid: 'Home',
//   permission: 'none',
//   weight: 1,
//   icon: ['fas', 'home']
// }));
